export default "/img/icons/logo.svg"